import dayjs from "dayjs";

/** Ordena entradas del tooltip de mayor a menor valor. */
export const tooltipItemSorterDesc = (item) => -(Number(item.value) || 0);

export const chartMonthLabelFormatter = (monthLabel) => {
  const parsed = dayjs(monthLabel, "MMM");
  return parsed.isValid() ? parsed.format("MMMM") : String(monthLabel ?? "");
};

/** Tooltip fijo en el centro del área del gráfico (solo cambia el contenido). */
export const dashboardFixedTooltipProps = {
  position: { x: 0, y: 0 },
  offset: 0,
  isAnimationActive: false,
  allowEscapeViewBox: { x: true, y: true },
  wrapperStyle: {
    transform: "none",
    width: "100%",
    height: "100%",
    pointerEvents: "none",
  },
};
